import { JetView } from 'webix-jet'; // Importing JetView for creating a Webix view
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing Webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix
import { countries } from '../../../../config/config'; // Importing countries configuration

/**
 * Class representing the FilterBonusReportView.
 * @extends JetView
 */
export default class FilterBonusReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        const left = {
            // Left section of the form
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    view: 'text', // Datepicker input
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true, // Read-only input
                    label: _("<span class='webix_icon icon-calendar'></span> Fecha"), // Label with icon
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
            ],
        };

        const center_left = {
            // Center left section of the form
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    view: 'richselect', // Dropdown for selecting state
                    name: 'State',
                    localId: 'bonusStates:combo',
                    label: _("<span class='icon-state'></span> Estado"), // Label with icon
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [
                        // Options for the dropdown
                        { id: '', value: 'Todos' },
                        { id: 'A', value: 'Activo' },
                        { id: 'I', value: 'Inactivo' },
                        { id: 'P', value: 'Pendiente' },
                        { id: 'R', value: 'Redimido' },
                        { id: 'E', value: 'Expirado' },
                        { id: 'L', value: 'Libre' },
                    ],
                },
            ],
        };

        const center_right = {
            // Center right section of the form
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    view: 'richselect', // Dropdown for selecting bonus type
                    name: 'BonusType',
                    localId: 'bonusTypes:combo',
                    label: _('Tipo'), // Label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [
                        // Options for the dropdown
                        { id: '', value: 'Todos' },
                        { id: '2', value: 'Deposito' },
                        { id: '3', value: 'No Deposito' },
                        { id: '6', value: 'FreeBet' },
                    ],
                },
            ],
        };

        const right = {
            // Right section of the form
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    view: 'text', // Input for Partner Bonus ID
                    name: 'PartnerBonusId',
                    type: 'number', // Numeric input
                    label: _("<span class='icon-id'></span> Partner Bono Id"), // Label with icon
                    labelPosition: 'top',
                    placeholder: _('Bono ID'), // Placeholder text
                    invalidMessage: _('Partner Bonus Id is required'), // Validation message
                },
            ],
        };

        const upper_section = {
            // Upper section containing all input fields
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right, right], // Columns layout
                },
            ],
        };

        const buttons = {
            // Button section
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form inputs
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'),
                    hotkey: 'enter', // Hotkey for the button
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('bonusReport:filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };

        return {
            // Return the complete form configuration
            view: 'form',
            rows: [upper_section, buttons],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form fields
            },
        };
    }
}

// FILE DOCUMENTED
